export const defaultPhrasierTheme = {
    colors: {
        bg: '#F2EEE5',
        surface: '#FAF7F0',
        surface2: '#FFFFFF',
        surfaceSub: '#ECE7DA',
        rule: '#E0D9C8',
        ruleStrong: '#C8BFA9',
        divider: '#EBE5D4',
        ink: '#1A1816',
        ink2: '#3D3934',
        inkMuted: '#6E665B',
        inkFaint: '#A39988',
        inkDisabled: '#C5BCA9',
        accent: '#1E3A8A',
        accentHover: '#243F94',
        accentPress: '#18316E',
        accentSoft: '#E0E5F2',
        accentInk: '#FFFFFF',
        focus: '#2954D6',
        accentRing: 'rgba(30,58,138,0.10)',
        success: '#2F6A3A',
        successSoft: '#DDE9DA',
        warning: '#946312',
        warningSoft: '#F2E6CC',
        error: '#98262F',
        errorSoft: '#EFD8D8',
        info: '#2A5A87',
        infoSoft: '#DDE6EF',
        connected: '#2F6A3A',
        disconnected: '#A39988'
    },
    spacing: {
        s0: '0',
        s1: '4px',
        s2: '8px',
        s3: '12px',
        s4: '16px',
        s5: '20px',
        s6: '24px',
        s7: '32px',
        s8: '40px',
        s9: '56px',
        s10: '72px'
    },
    radii: {
        xs: '3px',
        sm: '5px',
        md: '8px',
        lg: '12px',
        xl: '18px',
        pill: '999px'
    },
    typography: {
        fontDisplay: '"Newsreader", "Charter", "Iowan Old Style", Georgia, serif',
        fontSans: '"Geist", -apple-system, "SF Pro Text", "Helvetica Neue", sans-serif',
        fontMono: '"Geist Mono", "JetBrains Mono", "SF Mono", ui-monospace, monospace',
        display: '32px',
        h1: '22px',
        h2: '17px',
        h3: '14px',
        body: '13.5px',
        meta: '12px',
        mono: '11px'
    },
    shadows: {
        flat: '0 0 0 1px #E0D9C8',
        level1: '0 1px 0 0 rgba(26,24,22,0.04), 0 1px 2px -1px rgba(26,24,22,0.08)',
        level2: '0 1px 0 0 rgba(26,24,22,0.04), 0 4px 12px -4px rgba(26,24,22,0.12)',
        level3: '0 2px 0 0 rgba(26,24,22,0.04), 0 16px 32px -8px rgba(26,24,22,0.18)',
        inset: 'inset 0 0 0 1px #E0D9C8'
    },
    motion: {
        instant: '80ms',
        fast: '140ms',
        base: '220ms',
        slow: '340ms',
        easeOut: 'cubic-bezier(0.2, 0, 0, 1)',
        easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)'
    }
};
//# sourceMappingURL=PhrasierTheme.js.map